export const SEASONS = ['TRACHT', 'WINTER'];
export const BUILDING_TYPES = [
    'BROOD',
    'HONEY_STORE',
    'POLLEN_STORE',
    'WAX_GLAND',
    'GUARD_COMB',
    'WAR_COMB',
    'QUEEN_CELL',
    'DANCE_FLOOR',
];
export const UNIT_TYPES = ['FORAGER', 'SCOUT', 'GUARD', 'WARRIOR', 'HEATER', 'NURSE'];
export const MOVEMENT_TYPES = [
    'RAID',
    'SUPPORT',
    'TRANSPORT',
    'SCOUT',
    'GATHER',
    'COLONIZE',
    'QUEEN_DELIVERY',
    'RETURN',
];
export const RELATION_STATUS = ['ALLIED', 'NEUTRAL', 'HOSTILE'];
export const EVENT_TYPES = [
    'MOVEMENT_ARRIVE',
    'FIELD_GATHER_END',
    'MOVEMENT_RETURN',
    'BUILD_COMPLETE',
    'TRAIN_COMPLETE',
    'QUEEN_HATCH',
    'QUEENLESS_EXPIRE',
    'PROTECTION_EXPIRE',
    'SHIELD_EXPIRE',
    'WINTER_TICK',
];
export const EVENT_STATUS = ['PENDING', 'DONE', 'FAILED'];
export const FIELD_TYPES = ['RAPESEED', 'ORCHARD', 'MEADOW', 'LINDEN', 'HEATHER'];
export const MOVEMENT_STATUS = ['FLYING', 'GATHERING', 'STATIONED', 'RETURNING', 'DONE'];
export const REPORT_KINDS = [
    'RAID_ATTACK',
    'RAID_DEFENSE',
    'SCOUT',
    'SCOUT_DEFENSE',
    'FIELD_COMBAT',
    'QUEEN',
    'COLONIZE',
    'WINTER',
];
export const ALLIANCE_ROLES = ['LEADER', 'COUNCIL', 'DIPLOMAT', 'MEMBER', 'APPLICANT'];
export const CONVERSATION_KINDS = ['DM', 'ALLIANCE_CHANNEL', 'GROUP'];
export const QUEEN_STATES = ['LARVA', 'RULING', 'RESERVE', 'IN_TRANSIT', 'DEAD'];
/** Startquests (Konzept 11) in Reihenfolge. */
export const QUEST_KEYS = [
    'build_brood',
    'train_foragers',
    'first_harvest',
    'train_guards',
    'join_alliance',
];
export const TICKER_KINDS = [
    'PLAYER_JOINED',
    'ALLIANCE_FOUNDED',
    'ALLIANCE_DISSOLVED',
    'WAR_DECLARED',
    'BIG_FIGHT',
    'QUEEN_KILLED',
    'HIVE_TAKEN',
    'COLONY_FOUNDED',
    'WINTER_BEGINS',
    'SPRING_BEGINS',
];
export const PLAN_KINDS = ['ATTACK', 'DEFENSE'];
export const REPORT_REASONS = ['SPAM', 'HARASSMENT', 'CHEATING', 'OTHER'];
//# sourceMappingURL=constants.js.map